// Logging utility - only logs in development
export const devLog = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...args);
  }
};

export const devError = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(...args);
  } else {
    // In production, you might want to send to error tracking service
    // Example: Sentry.captureException(args[0]);
  }
};

export const devWarn = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(...args);
  }
};
